import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import logoBravas from "../../assets/img/bravaslogo.png";
import Input from "../../components/Input/Input";
import Loader from "../../components/Loader/Loader";
import Logo from "../../components/Logo/Logo";
import { useAuth } from "../../contexts/auth";
import FormEmailResetPassword from "../ResetPassword/FormEmailResetPassword/FormEmailResetPassword";
import SignUp from "../SignUp/SignUp";
import "./Login.css";
import Validate2FA from "../2fa/Validate2FA";
import { SESSION_STORE, useIndexedDb } from "../../contexts/indexedDb";
import NetworkBackground from "../../components/NetworkBackground/NetworkBackground";

export const routesByProfile = {
	auth: "/login",
	root: "/consulta-clientes",
	admin: "/consulta-condominios",
	operador: "/portaria",
};

function Login() {
	const [mail, setMail] = useState("");
	const [password, setPassword] = useState("");
	const [showLoader, setShowLoader] = useState(false);
	const [showSignUp, setShowSignUp] = useState(false);
	const [showResetPassword, setShowResetPassword] = useState(false);
	const [show2FA, setShow2FA] = useState(false);
	const navigate = useNavigate();
	const { signIn } = useAuth();
	const cookies = new Cookies();
	const location = useLocation();
	const { save: saveInCache, lastSessionData } = useIndexedDb();

	useEffect(() => {
		if (lastSessionData?.email) {
			setMail(lastSessionData.email);
		}
	}, [lastSessionData]);

	async function handleLogin(event) {
		event.preventDefault();
		setShowLoader(true);
		const response = await signIn(mail, password);
		setShowLoader(false);
		if (!response) return;
		await saveInCache?.({ id: SESSION_STORE, email: mail }, SESSION_STORE);
		if (response.userData?.twoFactorAuthentication) {
			setShow2FA(true);
		} else {
			navigate('../selecione-organizacao', { state: { ref: location.state?.ref } })
		}
	}

	const srcLogo = () => {
		let logo = cookies.get("LOGO_COOKIE");
		return logo && logo !== "null" && logo !== "undefined" ? logo : logoBravas;
	};

	return (
		<div
			className={`login-container ${showSignUp || showResetPassword ? "slide-left" : ""
				}`} style={{ height: '100vh', overflowY: 'auto', position: 'relative' }}
		>
			<NetworkBackground />
			{showSignUp ? (
				<SignUp onBack={() => setShowSignUp(false)} />
			) : showResetPassword ? (
				<FormEmailResetPassword onBack={() => setShowResetPassword(false)} />
			) : show2FA ? (
				<Validate2FA onCancel={() => {
					setShow2FA(false);
					setPassword("");
				}} onSuccess={() => {
					navigate('../selecione-organizacao')
				}} />
			) : (
				<form onSubmit={handleLogin} className="login-form-container">
					{
						showLoader ? (
							<Loader />
						) : (
							<div className="paper-background min-w-96! max-w-[28rem]!">
								<div className="login-logo-container">
									<Logo
										isLogin={true}
										src={srcLogo()}
										alt="logo"
									/>
								</div>
								<div className="login-form">
									<Input
										labelText={"Email"}
										placeholder="Email"
										type="text"
										name="email"
										value={mail}
										onChange={({ target }) => setMail(target.value)}
										required
									/>
									<Input
										labelText={"Senha"}
										name="password"
										id="password"
										placeholder="Digite sua senha"
										value={password}
										type="password"
										autoComplete="off"
										onChange={({ target }) => setPassword(target.value)}
										required
									/>
									<div className="form-buttons">
										<button type="submit" className="login-button">
											Entrar
										</button>
										<button
											type="button"
											className="login-button-cadastrar"
											onClick={() => setShowSignUp(true)}
										>
											Cadastre-se
										</button>
									</div>
									<button
										type="button"
										className="login-link"
										style={{ marginTop: "10px" }}
										onClick={() => setShowResetPassword(true)}
									>
										Esqueci minha senha
									</button>
								</div>
							</div>
						)}
				</form>
			)
			}
		</div >
	);
}

export default Login;
